import React, {ChangeEvent, useCallback, useEffect, useState} from "react";
import {glossaryStore} from "store/glossary/glossary.store";
import {debounce} from "lodash";
import {InputAdornment, OutlinedInput} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import CloseIcon from "@material-ui/icons/Close";
import useStyles from "./styles";

const GlossarySearchBar = () => {
  const classes = useStyles();
  const [searchQuery, setSearchQuery] = useState("");

  const setDebouncedSearchQuery = glossaryStore(
    (state) => state.setSearchQuery
  );

  const debouncedSearch = useCallback(
    debounce((value: string) => setDebouncedSearchQuery(value), 500),
    []
  );

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, []);

  const onChange = ({target}: ChangeEvent<HTMLInputElement>) => {
    const {value} = target;
    setSearchQuery(value);
    debouncedSearch(value.trim());
  };

  return (
    <OutlinedInput
      value={searchQuery}
      onChange={onChange}
      fullWidth
      startAdornment={
        <InputAdornment position="start">
          <SearchIcon className={classes.startAdornment} />
        </InputAdornment>
      }
      endAdornment={
        searchQuery ? (
          <InputAdornment
            position="end"
            onClick={() => {
              setSearchQuery("");
              setDebouncedSearchQuery("");
            }}
          >
            <CloseIcon className={classes.clearIcon} />
          </InputAdornment>
        ) : undefined
      }
      color="primary"
      classes={{input: classes.root, focused: classes.focused}}
      className={classes.searchBar}
      placeholder="Search..."
    />
  );
};

export default GlossarySearchBar;
